import { LoginInterface, LoginResponseInterface } from "@/components/Login/Login"
import { post } from "@/utils/valetSellerSApiClient.utils";

export const loginUser = (data: LoginInterface) => {
    return post<LoginResponseInterface>("/users/account/login", { ...data });
};
